import { msg } from '@lingui/core/macro'
import {
  FdeCdfSpecification,
  FdeCdfSpecificationList,
} from 'features/dataLayers/generation/fdeCdfSpecification'
import {
  ForecastComponentConfig,
  GeckoAssetModel,
  GeckoInspection,
  GeckoSource,
  GeckoTMinMethod,
  GeckoView,
} from 'types'

export const inspectionLayerLabels = {
  thickness: msg`Thickness`,
  corrosion_rate: msg`Corrosion rate`,
  metal_loss: msg`Metal loss`,
  remaining_life: msg`Remaining life`,
  minimum_thickness: msg`Minimum required thickness`,
  remaining_corrosion_allowance: msg`Remaining corrosion allowance`,
}
export type InspectionLayerKey = keyof typeof inspectionLayerLabels

export function inspectionLayerSpecification(
  key: InspectionLayerKey,
  method: GeckoTMinMethod | undefined
) {
  if (key === 'corrosion_rate') return FdeCdfSpecification.LossPerYear
  if (key === 'metal_loss') return FdeCdfSpecification.Loss
  if (key === 'thickness') return undefined
  return FdeCdfSpecificationList.find(
    (spec) =>
      spec.tminMethod === method &&
      (key === 'minimum_thickness'
        ? spec.source === GeckoSource.TMin
        : key === 'remaining_life'
          ? spec.view === GeckoView.RemainingLife
          : spec.view === GeckoView.RemainingCorrosionAllowance)
  )
}

export function availableInspectionLayers(
  model: GeckoAssetModel | undefined,
  componentId: string,
  config: ForecastComponentConfig | undefined,
  inspection: GeckoInspection | undefined,
  method: GeckoTMinMethod | undefined
): InspectionLayerKey[] {
  const keys: InspectionLayerKey[] = [
    'thickness',
    'corrosion_rate',
    'metal_loss',
    'remaining_life',
    'minimum_thickness',
    'remaining_corrosion_allowance',
  ]
  return keys.filter(
    (key) =>
      key === 'thickness' ||
      inspectionLayerSpecification(key, method)?.canCreateCdfData(
        model,
        componentId,
        config ?? {},
        inspection
      )
  )
}
